"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _BrightcovePlayer = _interopRequireDefault(require("../BrightcovePlayer/BrightcovePlayer.index"));

var _Modal = _interopRequireWildcard(require("../Modal/Modal.index"));

var _DictionaryTerms = require("./DictionaryTerms.api");

var _DictionaryTerms2 = require("./DictionaryTerms.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-console */
// Dictionary Term Modal for Brightcove videos
var DictionaryTermModal = function DictionaryTermModal(_ref) {
  var height = _ref.height,
      termParam = _ref.term,
      theme = _ref.theme,
      width = _ref.width,
      baseApiUrl = _ref.baseApiUrl;

  var _useModal = (0, _Modal.useModal)({
    isLoading: true,
    isOpen: true
  }),
      isLoading = _useModal.isLoading,
      isOpen = _useModal.isOpen,
      setIsLoading = _useModal.setIsLoading,
      toggle = _useModal.toggle;

  var _useState = (0, _react.useState)({
    definition: null,
    image: null,
    term: termParam,
    video: null
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      dictionaryTerm = _useState2[0],
      setDictionaryTerm = _useState2[1];

  (0, _react.useEffect)(function () {
    function fetchDictionaryTerm() {
      return _fetchDictionaryTerm.apply(this, arguments);
    }

    function _fetchDictionaryTerm() {
      _fetchDictionaryTerm = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var data, videoDictionaryTermTag, bc;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _DictionaryTerms.getTerm)(termParam, baseApiUrl);

              case 2:
                data = _context.sent;
                videoDictionaryTermTag = data.video;

                if (videoDictionaryTermTag) {
                  bc = new _autobahnUtilities.Brightcove(baseApiUrl);
                  bc.getDictionaryTermVideoId(videoDictionaryTermTag).then(function (videoId) {
                    setDictionaryTerm({
                      definition: data.definition,
                      image: data.image,
                      term: termParam,
                      video: videoId
                    });
                  })["catch"](function (e) {
                    return console.log("getDictionaryTermVideoId error: \"".concat(e, "\""));
                  })["finally"](setIsLoading(false));
                } else {
                  setDictionaryTerm(data);
                  setIsLoading(false);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchDictionaryTerm.apply(this, arguments);
    }

    fetchDictionaryTerm();
    return function () {};
  }, [setIsLoading, termParam, baseApiUrl]);
  var definition = dictionaryTerm.definition,
      image = dictionaryTerm.image,
      term = dictionaryTerm.term,
      video = dictionaryTerm.video;
  var hasMedia = !!video || !!image;
  var hasVideo = !!video;
  var formattedTerm = term.replaceAll('+', ' ');
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    height: height,
    hide: toggle,
    isLoading: isLoading,
    isOpen: isOpen,
    theme: theme,
    title: formattedTerm,
    width: width
  }, /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2.StyledDictionaryTermModal, null, /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2.StyledDictionaryTermModalContainer, {
    hasMedia: hasMedia
  }, hasMedia && /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2.StyledDictionaryTermModalMedia, {
    hasVideo: hasVideo
  }, hasVideo && /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2.StyledDictionaryTermModalVideo, null, /*#__PURE__*/_react["default"].createElement(_BrightcovePlayer["default"], {
    videoId: video,
    brightcoveplayer: theme.brightcoveplayer
  })), !hasVideo && /*#__PURE__*/_react["default"].createElement("img", {
    src: image,
    alt: formattedTerm
  })), /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2.StyledDictionaryTermModalContent, {
    hasVideo: hasVideo,
    hasMedia: hasMedia
  }, /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2.StyledDictionaryTermModalTitle, {
    hasVideo: hasVideo
  }, formattedTerm), /*#__PURE__*/_react["default"].createElement(_autobahnUtilities.DOMSanitizer, {
    element: "div"
  }, definition)))));
};

DictionaryTermModal.defaultProps = {
  theme: {},
  baseApiUrl: ''
};
DictionaryTermModal.propTypes = {
  height: _propTypes.number.isRequired,
  term: _propTypes.string.isRequired,
  theme: (0, _propTypes.shape)({}),
  width: _propTypes.number.isRequired,
  baseApiUrl: _propTypes.string
};
DictionaryTermModal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DictionaryTermModal",
  "props": {
    "theme": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "baseApiUrl": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "height": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    },
    "term": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "width": {
      "description": "",
      "type": {
        "name": "number"
      },
      "required": true
    }
  }
};
var _default = DictionaryTermModal;
exports["default"] = _default;